import Layout   from "./Box/Layout.es6";
import Bar      from "./Box/Bar.es6";
import Render   from "./Box/Render.es6";
import Buttons  from "./Box/Buttons.es6";

(() => {
    class Box extends App.Component {
        constructor(container) {
            super(container);
            this.price = false;
            this.addRenderBlockingPromise(App.Endpoint.Products.promise());
            this.update();
        }

        get quickBuy()  { return this.container.dataset.quickBuy === 'true' }
        get Layout()    { return this._layout || (this._layout = new Layout(this)) }
        get Bar()       { return this._bar || (this._bar = new Bar(this)) }
        get Render()    { return this._render || (this._render = new Render(this)) }
        get Buttons()   { return this._buttons || (this._buttons = new Buttons(this)) }
        get type()      { return this.container.dataset.type }

        get id()        { return this._id || (this._id = this.container.dataset.id) }
        set id(id) {
            this.container.dataset.id = id;
            this.update();
        }

        get hints() { return this.container.classList.contains('show-hints') }

        get values() {
            if (this.id === undefined) return undefined;
            switch (this.type) {
                case 'product':
                    return App.Endpoint.Products.getById(this.id);
            }
        }

        get badge() { return parseInt(this.container.dataset.badgeId) }

        get score() {
            return {
                'ratingCount': parseInt(this.container.dataset.ratingCount),
                'ratingMean': this.container.dataset.ratingMean
            };
        }

        get image() {
            return this.Layout.image.querySelector('img').getAttribute('src');
        }

        set image(image) {
            this.Layout.image.querySelector('img').src = image;
        }

        hasImage() {
            // this has to be the same filename as in app/templates/Layout/Components/Box.php
            return this.image && !this.image.endsWith('preloader.gif');
        }

        isCreatorMix() {
            // 3193 is the category ID for creator mixes
            return this.values.category == '3193';
        }

        setLayout(layout) {
            this.container.setAttribute('data-layout', layout);
            return this;
        }

        render() {
            if (this.values === undefined) return;
            switch (this.type) {
                case 'product':
                    this.Render.product().then(() => App.Components.apply());
                    break;
            }
        }

        update() {
            super.update(() => this.render());
        }
    }
    App.Components.register('.box', Box);
})();
